import {
  type ChanelActionType, type IncomingMessagePayload,
  type IWebSocketConnection, PublickConnectionChannels,
  type SubscribeToChannelResult, WebSocketConnectionManager
} from "../../index";
import type { OrderBookData, OrderBookModel } from "@trading/core";
import { OrderBookRepository } from "@trading/core";

export class OrderBookRepoWs implements OrderBookRepository {
  private wsChannel = PublickConnectionChannels['ORDER_BOOK']

  private unsubscribeHandler: (() => void) = () => {
    throw new Error("Method not initialized.");
  }
  private unsubscribeChannel: (() => void) = () => {
    throw new Error("Method not initialized.");
  }

  constructor(private wsManager: WebSocketConnectionManager) {
  }

  public async subscribeToChannelsAction(
    actionName: ChanelActionType,
    cb: (data: OrderBookData) => void
  ): Promise<undefined | ReturnType<IWebSocketConnection["subscribeToChannelMessages"]>> {
    // данный метод не используется т.к. нужна подписка на определенный инструмент
    throw new Error("Method not implemented.");
  }
  public async subscribeToChannelsActionByInstrument(
    instrument: string,
    actionName: ChanelActionType,
    cb: (data: OrderBookData) => void
  ): Promise<undefined | SubscribeToChannelResult> {
    const connection = await this.wsManager.getConnection('public')

    const unsubscribe = connection.subscribeToChannelMessages(this.wsChannel, {symbol: instrument})
    const removeHandler = connection.addChannelHandler(this.wsChannel, (data: IncomingMessagePayload<OrderBookModel>) => {
      if (data.type === actionName) {
        cb(data.data)
      }
    })
    this.unsubscribeChannel = unsubscribe
    this.unsubscribeHandler = removeHandler
    return { unsubscribe, removeHandler }

  }

  public unsubscribeToChannel(): void {
    this.unsubscribeHandler()
    this.unsubscribeChannel()
  }
}